import { http } from 'http';
import { createPaginationQuery } from 'helpers/store';

export default {
  getCampaigns: (partnerId, groupId, idC, pagination, filter) => {
    if (idC) {
      if (filter) {
        return http.get(
          `/catalog/${partnerId}/${groupId}/${idC}${createPaginationQuery(pagination)}${filter}`
        );
      }
      return http.get(
        `/catalog/${partnerId}/${groupId}/${idC}${createPaginationQuery(pagination)}`
      );
    }
    if (filter) {
      return http.get(
        `/catalog/${partnerId}/${groupId}${createPaginationQuery(pagination)}${filter}`
      );
    }

    return http.get(`/catalog/${partnerId}/${groupId}${createPaginationQuery(pagination)}`);
  },
  getCampaignDetail: (quoteId, partnerId, groupId) =>
    http.get(`/catalog/campaign/${quoteId}/${partnerId}/${groupId}?format[eqs]=collapse`),
  getStaticContent: channel =>
    http.get(`/popupstores/resourcetags?locale=es-ES&channel=${channel}`),
  getFilters: () => http.get('/masterdata/filters/STRATOS/shellType')
};
